import Loadable from 'react-loadable';
import Loading from 'components/Loading';
import {AppSettings} from '../constants';

const ManageBuilder = Loadable({
  loader: () => import('./Containers/manage-builders'),
  loading: Loading
});

const InviteBuilder = Loadable({
  loader: () => import('./Containers/invite-builder'),
  loading: Loading
});

const TermOfService = Loadable({
  loader: () => import('./Containers/TermOfService'),
  loading: Loading
});

const SetupBuilder = Loadable({
  loader: () => import('./Containers/SetupBuilder'),
  loading: Loading
});

const ConfigSite = Loadable({
  loader: () => import('./Containers/ConfigSite'),
  loading: Loading
});

export default [
  {
    path: '/builders',
    component: ManageBuilder,
    private: true,
    name: 'Builders',
    portal: ['System'],
    role: ['SystemPowerUser'],
    menu: {
      name: 'Builders',
      icons: 'icon-builders-ic',
      order: 2,
      condition: () => {
        return AppSettings.CURRENT_SITE_URI === AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  },
  {
    path: '/builders/invite-builder',
    component: InviteBuilder,
    name: 'Invite Builder',
    portal: ['System'],
    private: true
  },
  {
    path: '/client/term-of-service',
    name: 'Term of Service',
    portal: ['System'],
    component: TermOfService
  },
  {
    path: '/client/config-site',
    name: 'Configure Site',
    portal: ['System'],
    component: ConfigSite
  },
  {
    path: '/client/setup-builder',
    portal: ['System'],
    component: SetupBuilder
  }
];



// WEBPACK FOOTER //
// ./src/Builders/routes.js